import { api } from '@/lib/api-client';

import type {
  CalendarItemDto,
  CreateMaintenanceGuidePayload,
  CreateMaintenanceLogDto,
  CreateMaintenanceRecordPayload,
  CreateVehicleDto,
  MaintenanceGuideResponse,
  MaintenanceLogResponse,
  MaintenanceRecordResponse,
  MarcaResponse,
  ModeloResponse,
  UpdateMileageDto,
  VehiclePlanResponse,
  VehicleResponse,
} from '@kore/shared';

export interface UpdateVehiclePayload {
  brandId?: number;
  modelId?: number;
  year?: number;
  plate?: string;
  currentMileage?: number;
  averageDailyMileage?: number;
  alias?: string;
}

export const garageApi = {
  getBrands: (): Promise<MarcaResponse[]> => api.get('/vehicles/brands'),

  getModels: (brandId: number): Promise<ModeloResponse[]> =>
    api.get(`/vehicles/brands/${brandId}/models`),

  getVehicles: (): Promise<VehicleResponse[]> => api.get('/vehicles'),

  createVehicle: (payload: CreateVehicleDto): Promise<VehicleResponse> =>
    api.post('/vehicles', payload),

  updateVehicle: (id: number, payload: UpdateVehiclePayload): Promise<VehicleResponse> =>
    api.put(`/vehicles/${id}`, payload),

  deleteVehicle: (id: number): Promise<void> => api.delete(`/vehicles/${id}`),

  updateMileage: (id: number, payload: UpdateMileageDto): Promise<void> =>
    api.patch(`/vehicles/${id}/mileage`, payload),

  createLog: (
    vehicleId: number,
    payload: CreateMaintenanceLogDto,
  ): Promise<MaintenanceLogResponse> => api.post(`/vehicles/${vehicleId}/logs`, payload),

  getCalendar: (vehicleId: number): Promise<CalendarItemDto[]> =>
    api.get(`/vehicles/${vehicleId}/calendar`),

  getPlan: (vehicleId: number): Promise<VehiclePlanResponse> =>
    api.get(`/vehicles/${vehicleId}/plan`),

  // US#4 — Registros de mantenimiento (historial persistente).
  getRecords: (vehicleId: number): Promise<MaintenanceRecordResponse[]> =>
    api.get('/maintenance/records', { vehicleId }),

  createRecord: (payload: CreateMaintenanceRecordPayload): Promise<MaintenanceRecordResponse> =>
    api.post('/maintenance/records', payload),

  getGuides: (): Promise<MaintenanceGuideResponse[]> => api.get('/maintenance/guides'),

  getGuide: (id: number): Promise<MaintenanceGuideResponse> => api.get(`/maintenance/guides/${id}`),

  createGuide: (payload: CreateMaintenanceGuidePayload): Promise<MaintenanceGuideResponse> =>
    api.post('/maintenance/guides', payload),
};
